import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabelAccess, finalIncludedItems, trackCheckout } from '../data/offer';
const noMoreItems = ['No more Sunday evenings searching for technical progressions that actually work', 'No more classes that feel rushed or improvised', 'No more students losing motivation because sessions feel repetitive', 'No more weekends lost planning instead of living', 'No more walking onto the mat wishing you had prepared more'];
const trustItems = ['7-Day Money Back Guarantee', 'Secure Payment', 'Immediate Access', 'Pay in Your Local Currency'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-carbon-graphite" data-id="element-114" data-mp="qv58rrzkqmws">
      <div className="max-w-4xl mx-auto" data-id="element-115" data-mp="qxrpoi8cuero">
        <div className="text-center mb-16" data-id="element-116" data-mp="14uwtebklj1jr">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-117" data-mp="14vprko5hoiqa">
            Next Monday you can keep building your lessons from scratch...
            <br data-id="element-118" data-mp="2c5puhoei0zz0" />
            <span className="text-gold" data-id="element-119" data-mp="2c67rin8zji7z">
              Or you can walk onto the mat with everything ready — starting today.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-carbon p-8 rounded-2xl border border-carbon-line" data-id="element-120" data-mp="2m2b28hhwkp6j">
            {noMoreItems.map(item => <div key={item} className="flex items-start gap-3" data-id="element-121" data-mp="2qzkqhttk2uss">
                <span className="text-gold mt-0.5" aria-hidden="true" data-id="element-122" data-mp="2v2zhffj18vl0">▸</span>
                <span className="text-mist" data-id="element-123" data-mp="301k6qjwqxuuo">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-2" data-id="element-124" data-mp="34udd1c7v5b8v">
            Brazilian Jiu Jitsu Coach Ready does not make you a better instructor.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-125" data-mp="39u9fh70wwumb">You are already a great instructor.</p>
          <p className="text-xl text-mist mb-16" data-id="element-126" data-mp="3epotq02u0sj9">
            What BJJ Coach Ready does is give you the time and the tools to make
            that visible in every single class you teach.
          </p>
        </div>

        <div className="bg-carbon border-2 border-gold rounded-3xl p-6 md:p-12" data-id="element-127" data-mp="1epigrgfgvjej">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-gold/30 pb-6 font-serif" data-id="element-128" data-mp="1enfik945ujyq">
            Everything included in the <span className="text-gold" data-id="element-129" data-mp="1npou92b60jdp">6-in-1 system</span>:
          </h3>

          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-3 mb-10" data-id="element-130" data-mp="22ekyeoa3pc91">
            {finalIncludedItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-131" data-mp="1xgjddxt472ux">
                <CheckIcon size={18} className="text-gold shrink-0 mt-0.5" data-id="element-132" data-mp="2bfj1n4cptfqk" />
                <span className="text-sm text-mist" data-id="element-133" data-mp="2bdf0uva44wui">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-134" data-mp="27c39olblc3k7">
            <div className="mb-8 p-6 bg-carbon-graphite rounded-xl border border-gold/30 italic text-mist text-lg" data-id="element-135" data-mp="h0qapims1d4y">
              &quot;The best time to have this complete teaching system was before
              your very first BJJ class.
              <br data-id="element-136" data-mp="2wriihvjkt9x" />
              <span className="text-gold font-bold not-italic" data-id="element-137" data-mp="2yc6tpr9jfzc">The second best time is today.</span>
              &quot;
            </div>
            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-138" data-mp="3pcc8ck5g2wyn">
              📚 Brazilian Jiu Jitsu Coach Ready — Complete 6-in-1 Teaching System
            </p>
            <p className="text-sm text-smoke mb-6" data-id="element-139" data-mp="3fdmr8tldhgjg">
              100 BJJ lessons ready to teach — designed to help instructors plan
              less, teach with confidence and keep every session truly structured
              and fresh.
            </p>
            <div className="mb-6" data-id="element-140" data-mp="36e9jc5cwd00u">
              <span className="text-base text-ash line-through mr-3" data-id="element-141" data-mp="3bbrt1xyqnj9w">$105.00 USD</span>
              <span className="text-4xl font-extrabold text-gold" data-id="element-142" data-mp="3bdmdzca0fbdz">$27.00 USD</span>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-143" data-mp="14jh9h6ayyzh3">
              {ctaLabelAccess}
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-smoke" data-id="element-144" data-mp="30profwr289kq">
              {trustItems.map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-145" data-mp="2vr823v8k0vru">
                  <CheckIcon size={12} className="text-cta" data-id="element-146" data-mp="2rn8pvoub4j4a" /> {item}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}